module.exports = __webpack_public_path__ + "assets/img/00004.520dc713.png";